import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";

import AllUniformAddPopup from "../../../../components/modelpopup/AllUniformAddPopup";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import UniformListFilter from "../components/UniformListFilter";
import { Table, Pagination } from "antd";
import {
  itemRender,
  pageSizeOptions,
  handlePageChange,
  defaultPagination,
} from "utils/table";
import { formatDateHandler2, toTitleCase } from "utils/common";
import UniformStatusModal from "../../../../components/modelpopup/updateUserAllocation";

import { SkeltonLoader } from "components/skeltonLoader";
import UniformsFilterDrawer from "components/Drawer/uniformAllocationFilter";
import { useUniform } from "../context/uniformContext";
import Image from "components/Image";
import { toast, Bounce } from "react-toastify";
//import ColorPanel from "../components/ColorPanel";
import { getUniformsAllocationApi } from "api/services/uniforms";
//import { deleteUniformApi } from "api/services/uniforms";
import { useNavigate } from "react-router-dom";

import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button } from "components/Button";

const AllUniforms = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    searchText,
    uniformData,
    view,
    setView,

    handleGridChange,

    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleInputChange,

    filterLoading,

    handleUniformDetailPage,
    handleDateChange,
    createUniformHandler,
    uniformModal,
    setUniformModal,
  } = useUniform();
  const navigate = useNavigate();
  const {
    userData,
    userDataLoading,
    Position,
    PositionLoading,
    costCenterLoading,
    costCenter,
    position,positionLoading
  } = useSelector((state) => state.common);

  const [allocatedUniforms, setAllocatedUniforms] = useState([]);
  const [allocationModal, setAllocationModal] = useState(false);
  const[selectedAllocation, setSelectedAllocation] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageSettings, setPageSettings] = useState({
    ...defaultPagination,
    sortType: "asc",
    sortBy: "name",
  });
  const [filters, setFilters] = useState([
    {
      key: "search",
      label: "Search term",
      value: searchParams.get("search") || "",
    },
    {
      key: "position",
      label: "position",
      value: searchParams.get("position") || "",
    },
    {
      key: "cost_center",
      label: "Cost center",
      value: searchParams.get("cost_center") || "",
    },
  ]);

  useEffect(() => {
    if (!positionLoading && !costCenterLoading) {
      console.log(searchParams, "------searchParams");

      let selectedPosition = [...position].find(
        (item) => item.id == searchParams.get("position") || ""
      );

      let _filters = [
        {
          key: "search",
          label: "Search term",
          value: searchParams.get("search") || "",
        },

        {
          key: "position",
          label: "position",
          value: searchParams.get("position") || "",
        },
        {
          key: "cost_center",
          label: "Cost Center",
          value: searchParams.get("cost_center") || "",
        },
      ];
      setFilters(_filters);
    }
  }, [costCenter, position]);

  const handleFilterChange = (data, key, make_call = false) => {
    console.log("AAAA", data);

    let _filters = [...filters];
    let selectedFilter = _filters.find((item) => item.key === key);

    selectedFilter["label"] = data?.label || "";
    selectedFilter["value"] = data?.value || "";
    setFilters(_filters);
    console.log(_filters, "-----filtersssss");
    console.log(_filters, "AAAA");
    if (make_call) {
      setPageSettings({
        ...pageSettings,
        page: 1,
        filters: _filters,
      });
    }
  };
  const getFilterParams = useCallback(() => {
    let _filters = [...filters].filter((item) => item.value);
    const filter_params = _filters.reduce((acc, item) => {
      acc[item.key] = item.value;
      return acc;
    }, {});
    return filter_params;
  });
  const setDocumentParams = (pageData) => {
    let filter_params = getFilterParams();
    let params = {
      size: pageData?.pageSize,
      page: pageData?.page,
      sort_by: pageData?.sortBy || "",
      sort_type: pageData?.sortType || "",
      ...filter_params,
    };
    setSearchParams(params);
  };
  useEffect(() => {
    setDocumentParams(pageSettings);
  }, [pageSettings]);

  const getAllocatedUniforms = () => {
    setLoading(true);
    let filter_params = getFilterParams();
    let params = {
      sort_by: pageSettings?.sortBy,
      sort_type: pageSettings?.sortType,
      page_size: pageSettings?.pageSize,
      page: pageSettings?.page,
      group_by: "user",
      ...filter_params,
    };
    getUniformsAllocationApi(params)
      .then((response) => {
        setLoading(false);
        setAllocatedUniforms(response.data.results);

        console.log(response.data.results);
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getAllocatedUniforms();
  }, [
    pageSettings?.page,
    pageSettings?.pageSize,
    pageSettings?.sortBy,
    pageSettings?.sortType,
    pageSettings?.filters,
  ]);
  const handleEditUniform = (item) => {
    setUniformModal(true);
  };

  const handleDeleteUniform = (item) => {
    //setUniformModal(true)
  };

  const displayUniformPositions = (uniformPos = []) => {
    const positions = uniformPos || [];
    const visiblePositions = positions.slice(0, 2);
    const extraPositionsCount = positions.length - 2;

    return (
      <div className="d-flex flex-wrap">
        {visiblePositions.map((dept, index) => (
          <span
            key={index}
            className="badge badge-soft-primary px-3 py-1 m-1"
            style={{
              backgroundColor: "#f0f0f0",

              fontSize: "14px",
            }}
            title={dept.name}
          >
            {dept.name}
          </span>
        ))}

        {extraPositionsCount > 0 && (
          <span
            className="badge px-3 py-1 m-1"
            style={{
              backgroundColor: "#f0f0f0",
              color: "#333",
              borderRadius: "12px",
              fontSize: "14px",
            }}
            title={positions
              .slice(2)
              .map((dept) => dept.name)
              .join(", ")}
          >
            +{extraPositionsCount}
          </span>
        )}
      </div>
    );
  };

  const displayUniformColor = (colorVal, isText) => {
    return (
      <div className="d-flex align-items-center" style={{ gap: "8px" }}>
        <span
          style={{
            backgroundColor: colorVal,
            border: "1px solid #ccc",
            width: "24px",
            height: "24px",
            borderRadius: "4px",
            display: "inline-block",
          }}
        ></span>

        {isText ? (
          <span
            style={{
              display: "flex",
              alignItems: "center",
              height: "24px",
              fontSize: "14px",
            }}
          >
            {colorVal}
          </span>
        ) : (
          <></>
        )}
      </div>
    );
  };

  const displayUniformSizes = (uniformsizes = []) => {
    if (!uniformsizes.length) return <span>No sizes available</span>;

    const sizeOrder = ["XS", "S", "M", "L", "XL", "XXL"];

    const sortedSizes = uniformsizes
      .slice()
      .sort(
        (a, b) =>
          (sizeOrder.indexOf(a.code) !== -1
            ? sizeOrder.indexOf(a.code)
            : sizeOrder.length) -
          (sizeOrder.indexOf(b.code) !== -1
            ? sizeOrder.indexOf(b.code)
            : sizeOrder.length)
      );

    const visibleSizes = sortedSizes.slice(0, 3);
    const extraSizesCount = sortedSizes.length - 3;

    return (
      <div className="d-flex align-items-center">
        {/* Display first 3 sizes */}
        {visibleSizes.map((size, index) => (
          <span
            key={index}
            className="badge badge-soft-secondary px-2 py-1 mx-1"
            style={{
              borderRadius: "12px",
              fontSize: "14px",
            }}
            title={size.code} // Show size code on hover
          >
            {size.code}
          </span>
        ))}

        {/* Show +X more if there are more than 3 sizes */}
        {extraSizesCount > 0 && (
          <span
            className="badge px-2 py-1 mx-1"
            style={{
              backgroundColor: "#f0f0f0",
              color: "#333",
              borderRadius: "12px",
              fontSize: "14px",
            }}
            title={sortedSizes
              .slice(3)
              .map((size) => size.code)
              .join(", ")} // Show all remaining sizes on hover
          >
            +{extraSizesCount} more
          </span>
        )}
      </div>
    );
  };

  const displayUniformGender = (uniformGender) => {
    return (
      <span
        className="badge badge-soft-primary d-flex align-items-center"
        style={{ fontSize: "12px" }}
      >
        <i
          className={`la la-${
            uniformGender === "M"
              ? "mars"
              : uniformGender === "F"
              ? "venus"
              : "genderless"
          } me-1`}
        ></i>
        {uniformGender === "M"
          ? "Male"
          : uniformGender === "F"
          ? "Female"
          : "Unisex"}
      </span>
    );
  };

  const handleEmployeeDetailPage = (id, index) => {
    navigate(`/company-directory/${id}`);
  };

  const handleApplyFilter = () => {
    setPageSettings({
      ...pageSettings,
      page: 1,
      filters,
    });
  };

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      sorter: (a, b) => a.id - b.id,
      defaultSortOrder: "ascend",
      render: (text, record) => (
        <span className="table-avatar">{record.id}</span>
      ),
    },
    {
      title: "User",
      dataIndex: "first_name",
      sorter: true,
      render: (text, record, index) => (
        <h2 className="table-avatar d-flex">
          <a
            onClick={() =>
              handleEmployeeDetailPage(record?.company_user?.id, index)
            }
            className="avatar"
          >
            {/* <img alt="" src={record.profile_image} /> */}
            <Image src={record?.company_user?.profile_image} type="user" />
          </a>
          <a
            onClick={() =>
              handleEmployeeDetailPage(record?.company_user?.id, index)
            }
            className="profile-split d-flex flex-column"
          >
            {record?.company_user?.first_name} {record?.company_user?.last_name}{" "}
            <span>{record?.company_user?.emp_no}</span>
          </a>
        </h2>
      ),
    },
    //   {
    //     title: "Uniform",
    //     dataIndex: "first_name",
    //     sorter: true,
    //     render: (text, record, index) => (

    //       <h2 className="table-avatar d-flex">
    //         <a onClick={()=>handleEmployeeDetailPage(record?.company_user?.id, index)} className="w-50">
    //           {/* <img alt="" src={record.profile_image} /> */}
    //           <Image src={record?.uniform?.image}  type="object" className="w-50" />
    //         </a>
    //         <a  className="profile-split d-flex flex-column justify-content-center">
    //           {record?.uniform?.name}
    //         </a>
    //       </h2>
    //     ),

    //   },
    {
      title: "Email",
      dataIndex: "email",
      sorter: true,
      align: "center", // Ensures column text is centered
      render: (text, record) => <> {record?.company_user?.email} </>,
    },
    {
      title: "Designation",
      dataIndex: "position_name",
      sorter: true,
      align: "center", // Ensures column text is centered
      render: (text, record) => <> {record?.company_user?.position_name} </>,
    },
    // {
    //   title: "Color",
    //   dataIndex: "color",
    //   sorter: true,
    //   render: (text, record) => (
    //     <>
    //       { record?.uniform?.color }
    //     </>
    //   )
    // },

    // {
    //   title: "Gender",
    //   dataIndex: "gender",
    //   sorter: true,
    //   align: "center", // Ensures column text is centered
    //   render: (text, record) => (
    //     <> {displayUniformGender(record?.uniform?.gender)} </>
    //   )
    // },

    // {
    //   title: "Sizes",
    //   dataIndex: "sizes",
    // //   sorter: true,
    //   render: (text, record) => (
    //     <>
    //       {displayUniformSizes([record?.size||{}])}
    //     </>
    //   )

    // },

    // {
    //   title: "Positions",
    //   dataIndex: "positions",
    //   sorter: true,
    //   render: (text, record) => (
    //     <>
    //     {displayUniformPositions(record?.uniform?.positions)}
    //     </>
    //   )
    // },

    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   sorter: true,
    //   render: (text, record) => (
    //     <>

    //       <span className={`badge ${record?.status == "initiated" ? "badge-primary" : "badge-secondary"}`}
    //       style={{ fontSize: "0.75rem", padding: "5px 10px", fontWeight: "bold" }}
    //     >
    //       {record?.status }
    //     </span>
    //     </>
    //   )

    // },

    // {
    //     title: "Quantity",
    //     dataIndex: "quantity",
    //     sorter: true,
    //     render: (text, record) => (
    //       <>

    //         <span
    //       >
    //         {record?.quantity }
    //       </span>
    //       </>
    //     )

    //   },

    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   sorter: true,
    //   render: (text, record) => (
    //     <span className="table-avatar">
    //       {record.description}
    //     </span>
    //   )

    // },
    // {
    //   title: "Action",
    //   render: (text , record) => (
    //     <div className="dropdown dropdown-action text-end">
    //       <Link
    //         to="#"
    //         className="action-icon dropdown-toggle"
    //         data-bs-toggle="dropdown"
    //         aria-expanded="false"
    //       >
    //         <i className="material-icons">more_vert</i>
    //       </Link>
    //       <div className="dropdown-menu dropdown-menu-right">

    //         <Link
    //         onClick={()=>{
    //           setDeleteModal(true)
    //           setSelectedUniform(record)}}
    //           to="#"
    //           className="dropdown-item"
    //         >
    //           <i className="fa fa-trash m-r-5" /> Delete
    //         </Link>
    //       </div>
    //     </div>
    //   ),
    // }
  ];

  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {uniformData.map((record, index) => {
            const isWhiteColor =
              record?.color?.toLowerCase() === "#ffffff" ||
              record?.color?.toLowerCase() === "white";
            const isActive = record?.status || false;

            return (
              <div className="col-xxl-3 col-xl-4 col-md-6">
                <div
                  className="contact-grid p-3 border rounded d-flex position-relative"
                  style={{
                    minHeight: "220px",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "stretch",
                  }}
                >
                  {/* Top-right Controls: Dropdown Menu */}
                  <div className="position-absolute top-0 end-0 d-flex align-items-center p-2">
                    {/* Dropdown Menu Button */}
                    <div className="dropdown">
                      <button
                        className="btn btn-link p-0"
                        type="button"
                        id={`dropdownMenu-${record.id}`}
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="material-icons">more_vert</i>
                      </button>
                      <ul
                        className="dropdown-menu dropdown-menu-end"
                        aria-labelledby={`dropdownMenu-${record.id}`}
                      >
                        <li>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={() => handleEditUniform(record.id)}
                          >
                            <i className="fa-solid fa-pencil m-r-5"></i> Edit
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item text-danger"
                            href="#"
                            onClick={() => handleDeleteUniform(record.id)}
                          >
                            <i className="fa-regular fa-trash-can m-r-5"></i>{" "}
                            Delete
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* Uniform Image */}
                  <div className="uniform-image" style={{ flex: "0 0 40%" }}>
                    <a
                      onClick={() => handleUniformDetailPage(record.id, index)}
                    >
                      {record?.image ? (
                        <img
                          src={record.image}
                          alt={record.name}
                          className="rounded"
                          style={{
                            width: "100%",
                            height: "180px",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <div
                          className="no-image-placeholder d-flex align-items-center justify-content-center text-muted"
                          style={{
                            width: "100%",
                            height: "180px",
                            backgroundColor: "#f0f0f0",
                            textAlign: "center",
                            fontSize: "14px",
                            fontWeight: "bold",
                          }}
                        >
                          No Image Found
                        </div>
                      )}
                    </a>
                  </div>

                  {/* Uniform Details */}
                  <div className="ms-3 flex-grow-1 d-flex flex-column w-100">
                    {/* Uniform Name with Ellipsis */}
                    <h5
                      className="name-user mb-2"
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "calc(100% - 50px)", // Account for dropdown width
                        fontSize: "0.9rem", // Adjusted font size
                      }}
                      title={record?.name}
                    >
                      <a
                        onClick={() =>
                          handleUniformDetailPage(record.id, index)
                        }
                      >
                        {record?.name}
                      </a>
                    </h5>

                    {/* Gender & Color */}
                    <div className="d-flex justify-content-between text-muted mb-2">
                      <span>{displayUniformGender(record?.gender)}</span>

                      {/* Color Box with Border for White */}
                      <span
                        className="color-box"
                        style={{
                          backgroundColor: record?.color,
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          display: "inline-block",
                          border: isWhiteColor ? "1px solid #ccc" : "none",
                          position: "relative",
                        }}
                        title={record?.color || "Unknown Color"}
                      />
                    </div>

                    {/* Position Details */}
                    <div className="text-muted mb-2">
                      {record?.positions.length ? (
                        displayUniformPositions(record?.positions)
                      ) : (
                        <span
                          className="badge badge-soft-primary"
                          style={{ fontSize: "0.875rem", fontWeight: "normal" }}
                        >
                          Position N/A
                        </span>
                      )}
                    </div>

                    {/* Active Badge + Sizes */}
                    <div className="mt-auto d-flex align-items-center justify-content-between w-100">
                      {/* Active Status Badge */}
                      <span
                        className={`badge ${
                          isActive ? "badge-primary" : "badge-secondary"
                        }`}
                        style={{
                          fontSize: "0.75rem",
                          padding: "5px 10px",
                          fontWeight: "bold",
                        }}
                      >
                        {isActive ? "Active" : "Inactive"}
                      </span>

                      {/* Sizes */}
                      <div>{displayUniformSizes(record?.sizes)}</div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </>
      );
    }
  };

  const handleChange = (pagination, filters, sorter) => {
    let pageData = handlePageChange(pagination, filters, sorter, pageSettings);
    setPageSettings(pageData);
  };

  const handleSelectAllocation = (data) => {
    setSelectedAllocation(data)
    setAllocationModal(true)
  }
  // Render nested table for allocations
  const expandedRowRender = (record) => {
    const allocationColumns = [
      {
        title: "Uniform Name",
        dataIndex: ["uniform", "name"],
        key: "name",
      },
      {
        title: "Description",
        dataIndex: ["uniform", "description"],
        key: "description",
      },
      {
        title: "Color",
        dataIndex: ["uniform", "color"],
        key: "color",
        render: (color) => <></>,
      },
      {
        title: "Selected Sizes",
        dataIndex: ["uniform", "sizes"],
        key: "sizes",
        render: (sizes) => <></>,
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (status) => <></>,
      },
    ];

    return (
      <table className="table table-bordered" rowKey={"id"}>
        <thead>
          <tr>
            <td rowSpan={2} style={{ fontSize: 12 }}>
              Uniform
            </td>
            <td rowSpan={2} style={{ fontSize: 12 }}>
              Selected Size
            </td>
            {/* <td rowSpan={2} style={{ fontSize: 12 }}>
              {" "}
              Status
            </td> */}
            <td rowSpan={2} style={{ fontSize: 12 }}>
              {" "}
              Quantity
            </td>
            <td rowSpan={2} style={{ fontSize: 12 }}>
              Allocation Date
            </td>
            {/* <td rowSpan={2} style={{ fontSize: 12 }}>
              {" "}
              Gender
            </td>
            <td rowSpan={2} style={{ fontSize: 12 }}>
              {" "}
              Action
            </td> */}
          </tr>
        </thead>
        <tbody>
          {record?.allocations?.map((data) => (
            <tr key={data.uniform.id}>
              {/* Employee details */}
              <td style={{ fontSize: 12 }}>
                <h2 className="table-avatar d-flex">
                  <a className="  avatar">
                    {/* <img alt="" src={record.profile_image} /> */}
                    <Image src={data?.uniform?.image} type="object" />
                  </a>
                  <a className="profile-split d-flex flex-column justify-content-center">
                    {data?.uniform?.name}
                  </a>
                </h2>
              </td>
              <td style={{ fontSize: 12 }}>
                {displayUniformSizes([data?.size || {}])}
              </td>
              <td style={{ fontSize: 12 }}>{data?.quantity}</td>

              
              <td style={{ fontSize: 12 }}>{formatDateHandler2(data?.created_at)}</td>
              {/* <td style={{ fontSize: 12 }}>
                <span
                  className={`badge ${
                    data?.status == "initiated"
                      ? "badge-primary" 
                      : data?.status == "rejected" ? "badge-danger":
                      data?.status == "returned" ?  "badge-danger":
                      data?.status == "approved" ?  "badge-success":
                      data?.status == "acknowledged" ?  "badge-success":
                      data?.status == "received" ?  "badge-success":
                      "badge-secondary"
                  }`}
                  style={{
                    fontSize: "0.75rem",
                    padding: "5px 10px",
                    fontWeight: "bold",
                  }}
                >
          {toTitleCase(data?.status)}
                </span>
              </td> */}
              {/* <td style={{ fontSize: 12 }}>
                <div className="w-50" >
                    {displayUniformGender(data?.uniform?.gender)}
                    </div>
                
              </td> */}
              {/* <td style={{ fontSize: 12 }}>
              <Button onClick={()=> handleSelectAllocation(data)}  icon="fa fa-pencil me-2" label="Edit" className="btn btn-secondary ms-3 btn-sm" size="sm" /> 
                
              </td> */}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Allocated Uniforms"
            title="Dashboard"
            subtitle="Uniforms"
            modal="#add_uniform"
            name="Add Uniform"
            view={view}
            setUniformModal={setUniformModal}
            setView={setView}
          />

          <UniformListFilter
            filters={filters}
            handleInputChange={handleInputChange}
            searchPlaceholder={"Search Uniforms"}
            handleFilterDrawer={handleFilterDrawer}
            handleFilterChange={handleFilterChange}
            loading={loading}
          />

          {view == "grid" ? (
            <div className="row">
              <GridView />
              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                  <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    itemRender={itemRender}
                    onChange={handleGridChange}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="table-responsive">
                <Table
                // scroll={{ x: "max-content", y: "max-content" }} // 👈 Keeps horizontal scrollbar
                  className="table-striped"
                  columns={columns}
                  dataSource={allocatedUniforms}
                  rowKey={(record) => record?.company_user?.id}
                  loading={loading}
                  pagination={{
                    total: pageSettings?.total,
                    pageSize: pageSettings?.pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: pageSizeOptions,
                    // showQuickJumper: true,
                    itemRender: itemRender,
                    position: "right",
                    current: pageSettings?.page,
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`,
                  }}
                  onChange={handleChange}
                  expandable={{
                    expandedRowRender,
                    // defaultExpandedRowKeys: ['0'],
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <UniformStatusModal 
      fetchAllocation={getAllocatedUniforms}  
      allocationModal={allocationModal}
      setAllocationModal={setAllocationModal}
      selectedAllocation={selectedAllocation}
      setSelectedAllocation={setSelectedAllocation}
      />

      <UniformsFilterDrawer
        searchPlaceholder={"Search Uniforms"}
        showFilterDrawer={showFilterDrawer}
        handleFilterDrawer={handleFilterDrawer}
        handleFilterChange={handleFilterChange}
        filters={filters}
        handleInputChange={handleInputChange}
        handleApplyFilter={handleApplyFilter}
        filterLoading={filterLoading}
        handleDateChange={handleDateChange}
      />
      {/* Delete Modal */}
    </>
  );
};

export default AllUniforms;
